import { render, staticRenderFns } from "./VerdictsList.vue?vue&type=template&id=dedda238"
import script from "./VerdictsList.vue?vue&type=script&lang=js"
export * from "./VerdictsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports